import "./styles.scss";
import CadPessoaPage from "../../../Components/Cadastro/Pessoa/CadPessoaPage";

export default function CadPessoa() {
  return <CadPessoaPage path="carrier" />;
}
